<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :disable-routes="disableRoutes"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import { bus } from '@/main'
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getUser } from '@/services/configurations/getUser'
import { getHistoricalByUser } from '@/services/historical/getHistoricalByUser'
import { getHistoricalByUserExcel } from '@/services/historical/getHistoricalByUserExcel'

export default {
  name: 'list-user-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 22,
      vuexnamespace: 'historicalUser',
      headerUrl: 'configurations/users/details',
      breadcrumbs: [],
      ExcelName: `${_.kebabCase(i18n.t('users.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  mounted () {
    this.breadcrumbs = [
      { 
        url: this.role === 3 ? 'configurationssa' : 'configurations', 
        name: i18n.t('configurations.header') 
      },
      { url: 'configurations/users', name: i18n.t('users.header') },
      { paths: ['Usuario'] },
    ]
  },
  computed: { 
    role: function () {
      return this.$store.getters['auth/role']
    },
  },
  methods: {
    disableRoutes: function (user) {
      const isDisabledByRol = (user.idRol === 7 || user.idRol === 8 || user.idRol === 3)
      const isDisabledByProvider = user.idRol === 9
      const objDisableRoutes = {
        disableGroups: isDisabledByRol || isDisabledByProvider,
        disableStatuses: user.VerTodoEstados || isDisabledByRol || isDisabledByProvider,
        disableCompanies: user.VerTodoEmpresas || isDisabledByRol || isDisabledByProvider,
        disableProviderCompanies: !isDisabledByProvider
      }
      bus.$emit('disableOptionsUser', objDisableRoutes)
    },
    getParamsAux: function (data) {
      return { idUsuario: this.$route.params.id }
    },
    getParamsDetalleAux: function (data) {
      return this.getParamsAux(data)
    },
    getDetalleAux: async function (params) {
      return await getUser(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByUserExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByUser(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
